import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _lastIndexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/last-index-of";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TextSection from "./text-section.vue";
import { mapState } from "vuex";
import SelectSection from "./select-section.vue";
import YearsMonthsSection from "./years-months-section.vue";
import InlinePrompt from "../general/inline-prompt.vue";
import Amplitude from "@Shared/@Utils/amplitude";
import { PROVINCE_SELECT_OPTIONS } from "@Shared/utils/constants";
import { forEach, get, pickBy, reduce, isEmpty } from "lodash";
import AutocompleteSection from "./autocomplete-section.vue";
import { constructLine1 } from "@Shared/@Utils/utils";
import AddressLayout from "../layouts/general/address-layout.vue";
import GoogleMapWrapper from "../general/google-map-wrapper.vue";
import { defineComponent } from "@vue/composition-api";
import { validCanadianPostalCode } from "@Shared/@Utils/validation-rules";
import { validationMixin } from "vuelidate";
export default defineComponent({
  name: "AddressSection",
  components: {
    SelectSection,
    YearsMonthsSection,
    InlinePrompt,
    TextSection,
    AutocompleteSection,
    AddressLayout,
    GoogleMapWrapper
  },
  mixins: [validationMixin],
  provide() {
    if (this.$validator) {
      const providedObject = {
        $validator: this.$validator,
        mapLocationChanged: _mapInstanceProperty(this) ? this.handleGeoLocationChange : null
      };
      if (this.updateAll) {
        return _objectSpread(_objectSpread({}, providedObject), {}, {
          $validator: {
            value: this.$validator.value.$each.$iter[this.index]
          }
        });
      }
      return providedObject;
    }
  },
  inject: {
    $validator: {
      default: null
    }
  },
  validations: {
    address: {
      "postal-code": {
        validCanadianPostalCode
      }
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    tabindex: {
      type: [String, Number],
      default: "0"
    },
    replicate: {
      type: Boolean,
      default: false
    },
    replicateText: {
      type: String,
      default: ""
    },
    successReplicatedText: {
      type: String,
      default() {
        return this.replicateText;
      }
    },
    map: {
      type: Boolean,
      default: false
    },
    coapp: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    },
    time: {
      type: Boolean,
      default: false
    },
    containerClass: {
      type: String,
      default: ""
    },
    value: {
      type: [Object, Array],
      default: () => ({})
    },
    updateAll: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Boolean,
      default: false
    },
    maxLengthValidations: {
      type: Object,
      default: null
    },
    path: {
      type: String,
      default: null
    },
    validationPath: {
      type: String,
      default: null
    },
    applicationValidations: {
      type: Object,
      default: null
    },
    className: {
      type: String,
      default: ""
    },
    translationMap: {
      type: Object,
      default: null
    },
    googleMaps: {
      type: Boolean,
      default: false
    },
    displaySetAsCurrent: {
      type: Boolean,
      default: false
    },
    showLabels: {
      type: Boolean,
      default: false
    },
    showTooltipMessage: {
      type: Boolean,
      default: false
    },
    editVisibility: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      address: this.updateAll ? this.value[this.index] : this.value,
      forceMirror: false,
      geolocation: {
        viewport: null,
        location: null
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("ApplicationStore", {
    currentApplication(state) {
      if (state.application) {
        return state.application;
      } else {
        const {
          currentApplicationId,
          applications
        } = state;
        return applications.byId[currentApplicationId];
      }
    }
  })), {}, {
    postalInvalid() {
      return !!this.$v.address["postal-code"].$invalid;
    },
    mirrorAddress() {
      if (!this.replicatePath || this.index !== 0) return {};
      const {
        path,
        index
      } = this.replicatePath;
      if (!path) return {};
      return get(this.currentApplication, path)[index];
    },
    hasErrorMessages() {
      return this.errorMessages.length > 0;
    },
    isMirror() {
      if (!this.replicate) return false;
      const {
        mirrorString,
        addressString
      } = this;
      if (!mirrorString || !addressString) return false;
      return mirrorString && addressString && mirrorString === addressString;
    },
    lookupClass() {
      const classes = "fe-address-autocomplete address-lookup form-control";
      return `${classes} ${_mapInstanceProperty(this) ? "fe-map-address" : ""}`;
    },
    timeAtClass() {
      const classes = "form required form-control fe-num-field residence-years time-at-residence";
      return `${classes} ${this.coapp ? "coapp" : ""}`;
    },
    addressString() {
      if (!this.replicate) return "";
      const {
        line1 = "",
        line2 = "",
        "unit-number": unitNumber = "",
        province = "",
        city = "",
        "postal-code": postal = "",
        "time-at": timeAt = ""
      } = this.address;
      // double check defaults because of nulls may be present
      return `${line1 || ""}${line2 || ""}${unitNumber || ""}${postal || ""}${province || ""}${city || ""}${timeAt || ""}`;
    },
    mirrorString() {
      if (!this.replicate) return "";
      const {
        line1 = "",
        line2 = "",
        "unit-number": unitNumber = "",
        province = "",
        city = "",
        "postal-code": postal = "",
        "time-at": timeAt = ""
      } = this.mirrorAddress;
      // double check defaults because of nulls may be present
      return `${line1 || ""}${line2 || ""}${unitNumber || ""}${postal || ""}${province || ""}${city || ""}${timeAt || ""}`;
    },
    replicated() {
      return this.value.replicated;
    },
    replicatePath() {
      if (this.value.replicated && this.index === 0) {
        return this.value.replicated;
      }
      return null;
    },
    maxLengthValidationsToUse() {
      const defaultMaxLengthValidations = {
        line1: 35,
        line2: 35,
        unitNumber: 10,
        streetNumber: 10,
        streetName: 30,
        city: 20,
        postalCode: 20
      };
      return this.maxLength ? _objectSpread(_objectSpread({}, this.maxLengthValidations), defaultMaxLengthValidations) : {};
    },
    errorMessages() {
      try {
        if (!this.applicationValidations) return [];
        return reduce(this.applicationValidations, (acc, current, key) => {
          if (key != null && _includesInstanceProperty(key).call(key, this.validationPath)) {
            const validationKey = key.substr(_lastIndexOfInstanceProperty(key).call(key, "["), _lastIndexOfInstanceProperty(key).call(key, "]")).replace("[", "").replace("]", "");
            acc[validationKey] = current.message;
          }
          return acc;
        }, {});
      } catch (e) {
        const errMessage = "Some fields on this address have invalid lenghts. Please, review";
        Amplitude.logHandledError(e, {}, errMessage);
        return [errMessage];
      }
    },
    computedTitle() {
      return this.$options.filters.getSchemaTranslation(this.title, this.translationMap);
    },
    provinceOptions() {
      return PROVINCE_SELECT_OPTIONS();
    },
    enableGoogleMaps() {
      return !isEmpty(this.address["city"]) && !isEmpty(this.address["province"]) && !isEmpty(this.address["street-name"]) && !isEmpty(this.address["street-number"]) && this.googleMaps;
    },
    openGoogleMaps() {
      const address = `${this.address["street-number"]} ${this.address["street-name"]} ${this.address["city"]} ${this.address["province"]}`;
      return "#/widgets/google-map/?address=" + address;
    }
  }),
  watch: {
    value(newVal) {
      this.address = this.updateAll ? newVal[this.index] : newVal;
    },
    address: {
      //Watch for address change to reconstruct address line1
      handler(val, oldVal) {
        const transformedAddress = constructLine1(val, oldVal);
        if (transformedAddress) {
          this.handleAddressAutocompleteChange(transformedAddress);
        }
      },
      deep: true
    },
    mirrorString() {
      for (const key in this.mirrorAddress) {
        this.eventAdapter({
          target: {
            name: key,
            value: this.mirrorAddress[key]
          }
        });
      }
    },
    addressString() {
      if (this.isMirror || this.forceMirror) {
        for (const key in this.mirrorAddress) {
          this.eventAdapter({
            target: {
              name: key,
              value: this.mirrorAddress[key]
            }
          });
        }
      }
    },
    isMirror(value) {
      if (value === false) {
        this.eventAdapter({
          target: {
            name: "replicated",
            value: null
          }
        });
      }
      if (this.addressString !== this.mirrorAddress) {
        this.forceMirror = false;
      }
    }
  },
  methods: {
    addressWrapperClass(index) {
      const classes = "row small-gutters align-items-end address-wrapper";
      return `${classes} ${index > 0 ? "mt-3" : ""}`;
    },
    /**
     * Adapter to handle the multiple ways of components triggering change
     * handle event changes callback as:
     *
     * handleChange(value, event) -> params = [value, event]
     * handleChange(event)-> params = [event]
     *
     */
    eventAdapter(...params) {
      const value = params.length === 1 ? params[0].target.value : params[0];
      const event = params.length === 1 ? params[0] : params[1];
      return this.handleChange(event, value === "" ? "" : value);
    },
    handleChange(event, value) {
      const name = event.target.name;
      if (this.updateAll) {
        // mutation for addresses array
        this.address = _objectSpread(_objectSpread({}, this.address), {}, {
          [name]: value
        });
        const addresses = [...this.value];
        addresses[this.index] = this.address;
        this.$emit("change", addresses);
      } else if (this.index != null) {
        // mutation from mapMultiRowFields
        //eslint-disable-next-line vue/no-mutating-props
        this.value[name] = value;
        this.address[name] = value;
      } else {
        // mutation from mapFields
        this.address = _objectSpread(_objectSpread({}, this.address), {}, {
          [name]: value
        });
        this.$emit("change", this.getValidAddressObject(this.address));
      }
    },
    titleValue(index) {
      if (this.computedTitle.toLowerCase() !== "current address") return this.computedTitle;

      //TODO: manual i18n for this
      return index > 0 ? `${this.$t("application-form.previous-address")} ${index}` : this.$t("application-form.current-address");
    },
    removeAddress() {
      this.$emit("remove");
    },
    replicateAddress() {
      this.$emit("replicate");
      this.forceMirror = true;
    },
    getValidAddressObject(address) {
      return pickBy(address, (val, key) => {
        var _context;
        return !_includesInstanceProperty(_context = ["lookup", "formatted-address"]).call(_context, key);
      });
    },
    handleAddressAutocompleteChange(addressObject) {
      if (this.updateAll) {
        this.address = _objectSpread(_objectSpread({}, this.address), addressObject);
        const addresses = [...this.value];
        addresses[this.index] = this.address;
        this.$emit("change", addresses);
      } else if (this.index != null) {
        // mutation from mapMultiRowFields
        forEach(addressObject, (value, key) => {
          //eslint-disable-next-line vue/no-mutating-props
          this.value[key] = value;
          this.address[key] = value;
        });
      } else {
        // mutation from mapFields
        forEach(addressObject, (value, key) => {
          this.address[key] = value;
        });
        this.$emit("change", this.getValidAddressObject(this.address));
      }
    },
    handleGeoLocationChange({
      viewport,
      location
    }) {
      this.geolocation = {
        viewport,
        location
      };
    },
    handleChangeAddressToCurrent() {
      this.$emit("set-as-current");
    }
  }
});